export const demoMarktanalyseData = [
  {
    LocationScores: {
      scores: {
        health: {
          isOverridden: false,
          originalScore: 1,
          score: 1,
        },
        leisure: {
          isOverridden: false,
          originalScore: 0.925,
          score: 0.925,
        },
        family: {
          isOverridden: false,
          originalScore: 1,
          score: 1,
        },
        shopping: {
          isOverridden: false,
          originalScore: 1,
          score: 1,
        },
        catering: {
          isOverridden: false,
          originalScore: 1,
          score: 1,
        },
      },
      health: 1,
      leisure: 0.925,
      family: 1,
      shopping: 1,
      catering: 1,
    },
    PointsOfInterest: {
      items: [
        {
          name: 'Zum schwarzen Adler',
          category: 'health',
          subcategory: 'pharmacy',
          location: {
            coordinates: {
              latitude: 48.20198059082031,
              longitude: 16.39097023010254,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '60',
            },
          },
          distance: 9,
        },
        {
          name: 'PENNY',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.202152252197266,
              longitude: 16.39076042175293,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '58',
            },
          },
          distance: 34,
        },
        {
          name: 'Rochus',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.202110290527344,
              longitude: 16.39148712158203,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '55-57',
            },
          },
          distance: 38,
        },
        {
          name: 'Akakiko',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.201988220214844,
              longitude: 16.39158058166504,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '59',
            },
          },
          distance: 39,
        },
        {
          name: 'W.I.F',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20222854614258,
              longitude: 16.390657424926758,
            },
          },
          distance: 45,
        },
        {
          name: 'Isoda',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20256423950195,
              longitude: 16.390974044799805,
            },
          },
          distance: 72,
        },
        {
          name: 'Rochusgasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.202574150000004,
              longitude: 16.390664649999998,
            },
          },
          distance: 78,
        },
        {
          name: 'El Gaucho',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.2026481628418,
              longitude: 16.391529083251953,
            },
          },
          distance: 88,
        },
        {
          name: 'Rochusgasse',
          category: 'transport',
          subcategory: 'subway',
          location: {
            coordinates: {
              latitude: 48.2020851,
              longitude: 16.3922544,
            },
          },
          distance: 90,
        },
        {
          name: 'Arrigo',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.202728271484375,
              longitude: 16.39084243774414,
            },
          },
          distance: 91,
        },
        {
          name: 'Rochusgasse',
          category: 'transport',
          subcategory: 'train',
          location: {
            coordinates: {
              latitude: 48.20209835,
              longitude: 16.392268950000002,
            },
          },
          distance: 92,
        },
        {
          name: 'BORG 3 Landstraße',
          category: 'education',
          subcategory: 'school',
          location: {
            coordinates: {
              latitude: 48.201072692871094,
              longitude: 16.391061782836914,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '70',
            },
          },
          distance: 93,
        },
        {
          name: 'St. Rochus-Apotheke',
          category: 'health',
          subcategory: 'pharmacy',
          location: {
            coordinates: {
              latitude: 48.202537536621094,
              longitude: 16.390195846557617,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '50',
            },
          },
          distance: 94,
        },
        {
          name: 'Benedikt',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20237731933594,
              longitude: 16.389963150024414,
            },
            address: {
              postCode: '1030',
              street: 'Sechskrügelgasse',
              city: 'Wien',
              houseNumber: '2',
            },
          },
          distance: 96,
        },
        {
          name: 'Stammkaffee',
          category: 'catering',
          subcategory: 'bar',
          location: {
            coordinates: {
              latitude: 48.20186233520508,
              longitude: 16.389713287353516,
            },
            address: {
              postCode: '1030',
              street: 'Sechskrügelgasse',
              city: 'Wien',
              houseNumber: '1',
            },
          },
          distance: 100,
        },
        {
          name: 'Le Firin',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.202816009521484,
              longitude: 16.391265869140625,
            },
          },
          distance: 101,
        },
        {
          name: 'Abby',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.202606201171875,
              longitude: 16.390138626098633,
            },
          },
          distance: 102,
        },
        {
          name: 'Rochusgasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.2022919,
              longitude: 16.3923755,
            },
          },
          distance: 106,
        },
        {
          name: 'Pfarrgemeinde',
          category: 'leisure',
          subcategory: 'entertainment',
          location: {
            coordinates: {
              latitude: 48.20130157470703,
              longitude: 16.389867782592773,
            },
          },
          distance: 111,
        },
        {
          name: 'Pappa e Ciccia',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20286178588867,
              longitude: 16.390398025512695,
            },
            address: {
              postCode: '1030',
              street: 'Rochusmarkt',
              city: 'Wien',
            },
          },
          distance: 115,
        },
        {
          name: 'Nata Lisboa',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.2012939453125,
              longitude: 16.392345428466797,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '65',
            },
          },
          distance: 118,
        },
        {
          name: 'Dr. Maximilian Walther',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20188903808594,
              longitude: 16.389394760131836,
            },
          },
          distance: 123,
        },
        {
          name: 'Çağla Pâtisserie',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.2010498046875,
              longitude: 16.39213752746582,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '72',
            },
          },
          distance: 125,
        },
        {
          name: 'Billa Plus',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20294952392578,
              longitude: 16.39175033569336,
            },
          },
          distance: 125,
        },
        {
          name: 'Dr. Hanna Röhsler',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.203060150146484,
              longitude: 16.390947341918945,
            },
          },
          distance: 127,
        },
        {
          name: 'Biotto',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20167541503906,
              longitude: 16.389366149902344,
            },
          },
          distance: 128,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.2020263671875,
              longitude: 16.39287567138672,
            },
          },
          distance: 135,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.20198059082031,
              longitude: 16.39289665222168,
            },
          },
          distance: 136,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.201934814453125,
              longitude: 16.39297866821289,
            },
          },
          distance: 142,
        },
        {
          name: 'Rochuspark',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.20206832885742,
              longitude: 16.392986297607422,
            },
          },
          distance: 144,
        },
        {
          name: 'Stellas',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20294952392578,
              longitude: 16.38986587524414,
            },
          },
          distance: 145,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.20071792602539,
              longitude: 16.39015769958496,
            },
          },
          distance: 149,
        },
        {
          name: 'Petrus-Apotheke',
          category: 'health',
          subcategory: 'pharmacy',
          location: {
            coordinates: {
              latitude: 48.20254898071289,
              longitude: 16.392908096313477,
            },
            address: {
              postCode: '1030',
              street: 'Erdbergstraße',
              city: 'Wien',
              houseNumber: '6',
            },
          },
          distance: 154,
        },
        {
          name: 'Zuckergoscherl',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20326614379883,
              longitude: 16.390426635742188,
            },
          },
          distance: 157,
        },
        {
          name: 'Friedrich-Gulda-Park',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.20243835449219,
              longitude: 16.388935089111328,
            },
          },
          distance: 168,
        },
        {
          name: 'Tierambulatorium Erdberg',
          category: 'health',
          subcategory: 'veterinary',
          location: {
            coordinates: {
              latitude: 48.202857971191406,
              longitude: 16.39290428161621,
            },
          },
          distance: 172,
        },
        {
          name: 'Grete-Jost-Park',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.20323944091797,
              longitude: 16.39244270324707,
            },
          },
          distance: 179,
        },
        {
          name: 'Hannibals',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20343017578125,
              longitude: 16.390071868896484,
            },
          },
          distance: 183,
        },
        {
          name: 'Wiener Seifen Manufaktur',
          category: 'shopping',
          subcategory: 'convenience_store',
          location: {
            coordinates: {
              latitude: 48.200347900390625,
              longitude: 16.391826629638672,
            },
            address: {
              postCode: '1030',
              street: 'Hintzerstraße',
              city: 'Wien',
              houseNumber: '6',
            },
          },
          distance: 183,
        },
        {
          name: 'Sternzeichen',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20058822631836,
              longitude: 16.39258575439453,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '78-80',
            },
          },
          distance: 186,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.20314407348633,
              longitude: 16.39276885986328,
            },
          },
          distance: 186,
        },
        {
          name: 'Moped',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20359802246094,
              longitude: 16.390583038330078,
            },
            address: {
              postCode: '1030',
              street: 'Salmgasse',
              city: 'Wien',
              houseNumber: '23',
            },
          },
          distance: 190,
        },
        {
          name: 'Prof. Priv.-Doz. Dr. M. Hoke FA für Innere Medizin und Angiologie',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.200225830078125,
              longitude: 16.390655517578125,
            },
            address: {
              postCode: '1030',
              street: 'Hintzerstraße',
              city: 'Wien',
              houseNumber: '10',
            },
          },
          distance: 190,
        },
        {
          name: 'Istanbul',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20330810546875,
              longitude: 16.389535903930664,
            },
          },
          distance: 191,
        },
        {
          name: "Trattoria Pizzeria All'Italiana",
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20107650756836,
              longitude: 16.39335823059082,
            },
          },
          distance: 194,
        },
        {
          name: 'Dr. Marcel Rowhani',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.201194763183594,
              longitude: 16.393455505371094,
            },
          },
          distance: 195,
        },
        {
          name: 'Dr. Helga Benko',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20351028442383,
              longitude: 16.389942169189453,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '37',
            },
          },
          distance: 195,
        },
        {
          name: "denn's Biomarkt",
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20349884033203,
              longitude: 16.389881134033203,
            },
          },
          distance: 196,
        },
        {
          name: 'Dr. Dr. Lukas',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.20074462890625,
              longitude: 16.39311408996582,
            },
          },
          distance: 200,
        },
        {
          name: 'Hintzerstraße',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.20053435,
              longitude: 16.3929099,
            },
          },
          distance: 206,
        },
        {
          name: 'Habibi & Hawara',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.2027702331543,
              longitude: 16.393529891967773,
            },
            address: {
              postCode: '1030',
              street: 'Platz der Sozialen Sicherheit',
              city: 'Wien',
            },
          },
          distance: 206,
        },
        {
          name: 'Ströck Feierabend',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.200416564941406,
              longitude: 16.392824172973633,
            },
            address: {
              postCode: '1030',
              street: 'Hintzerstraße',
              city: 'Wien',
              houseNumber: '1',
            },
          },
          distance: 212,
        },
        {
          category: 'leisure',
          subcategory: 'entertainment',
          location: {
            coordinates: {
              latitude: 48.20378494262695,
              longitude: 16.391809463500977,
            },
            address: {
              postCode: '1030',
              street: 'Rasumofskygasse',
              city: 'Wien',
            },
          },
          distance: 215,
        },
        {
          name: 'Kundmanngasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.2025517,
              longitude: 16.3938796,
            },
          },
          distance: 221,
        },
        {
          name: 'Dr. Maria Heger',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.200496673583984,
              longitude: 16.393280029296875,
            },
          },
          distance: 228,
        },
        {
          name: 'Vitavien Landstrasse',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.203826904296875,
              longitude: 16.38953971862793,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '33',
            },
          },
          distance: 240,
        },
        {
          name: 'evang. Kindergarten',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.2000846862793,
              longitude: 16.389190673828125,
            },
            address: {
              postCode: '1030',
              street: 'Sebastianplatz',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 246,
        },
        {
          name: 'Billa',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20366668701172,
              longitude: 16.38901710510254,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '32',
            },
          },
          distance: 246,
        },
        {
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.19972610473633,
              longitude: 16.39167022705078,
            },
          },
          distance: 247,
        },
        {
          name: 'Noodleking',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20027542114258,
              longitude: 16.39342498779297,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '79',
            },
          },
          distance: 253,
        },
        {
          name: 'Dr. Hellmuth Schwanzer-Taborsky',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19969940185547,
              longitude: 16.390037536621094,
            },
            address: {
              postCode: '1030',
              street: 'Sebastianplatz',
              city: 'Wien',
              houseNumber: '7',
            },
          },
          distance: 257,
        },
        {
          name: 'BG und BRG Wien 3 Kundmanngasse',
          category: 'education',
          subcategory: 'school',
          location: {
            coordinates: {
              latitude: 48.20358657836914,
              longitude: 16.39348793029785,
            },
            address: {
              postCode: '1030',
              street: 'Kundmanngasse',
              city: 'Wien',
              houseNumber: '20-22',
            },
          },
          distance: 259,
        },
        {
          name: 'Café Vilimek',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20022201538086,
              longitude: 16.393478393554688,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '79',
            },
          },
          distance: 260,
        },
        {
          name: 'Dr. Herbert Schuster',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20208740234375,
              longitude: 16.387540817260742,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '27',
            },
          },
          distance: 262,
        },
        {
          name: 'Ristorante Trimelli',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.2039794921875,
              longitude: 16.38933753967285,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '31',
            },
          },
          distance: 262,
        },
        {
          name: 'Meze Meze',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20143127441406,
              longitude: 16.387582778930664,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '31',
            },
          },
          distance: 263,
        },
        {
          name: 'Wiki Wiki Poke',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20378494262695,
              longitude: 16.38882064819336,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '30',
            },
          },
          distance: 266,
        },
        {
          name: 'Café Restaurant Hotel Biedermeier',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.2034912109375,
              longitude: 16.38821029663086,
            },
          },
          distance: 274,
        },
        {
          name: 'Haubenstock-Ramati-Park',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.19961166381836,
              longitude: 16.38970375061035,
            },
          },
          distance: 275,
        },
        {
          name: 'Sechskrügelgasse',
          category: 'transport',
          subcategory: 'tram',
          location: {
            coordinates: {
              latitude: 48.201969000000005,
              longitude: 16.3873098,
            },
          },
          distance: 278,
        },
        {
          name: 'Schule des Schulvereins Komensky',
          category: 'education',
          subcategory: 'school',
          location: {
            coordinates: {
              latitude: 48.19979476928711,
              longitude: 16.38905906677246,
            },
            address: {
              postCode: '1030',
              street: 'Sebastianplatz',
              city: 'Wien',
              houseNumber: '3',
            },
          },
          distance: 278,
        },
        {
          name: 'Heurigenkeller',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20365524291992,
              longitude: 16.388351440429688,
            },
          },
          distance: 278,
        },
        {
          name: 'Im Sünnhof',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20361328125,
              longitude: 16.388246536254883,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '28',
            },
          },
          distance: 281,
        },
        {
          name: 'Spielplatz des evang. Kindergarten',
          category: 'leisure',
          subcategory: 'playground',
          location: {
            coordinates: {
              latitude: 48.19999694824219,
              longitude: 16.38856315612793,
            },
          },
          distance: 282,
        },
        {
          name: 'Weißgerberstube',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20384216308594,
              longitude: 16.388553619384766,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '28',
            },
          },
          distance: 283,
        },
        {
          name: 'Auge im Dritten',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.200801849365234,
              longitude: 16.387577056884766,
            },
          },
          distance: 286,
        },
        {
          name: "Daria's Nüsse & Co",
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.200008392333984,
              longitude: 16.39368438720703,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '81',
            },
          },
          distance: 288,
        },
        {
          name: 'Hofer',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20395278930664,
              longitude: 16.38864517211914,
            },
          },
          distance: 288,
        },
        {
          name: 'Vulcano',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.200843811035156,
              longitude: 16.38751220703125,
            },
            address: {
              postCode: '1030',
              street: 'Rochusgasse',
              city: 'Wien',
              houseNumber: '25',
            },
          },
          distance: 289,
        },
        {
          name: 'Dr. Claudia Heller-Vitouch',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20198059082031,
              longitude: 16.387165069580078,
            },
          },
          distance: 289,
        },
        {
          name: 'Dr. Wolfgang Trubel',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.200923919677734,
              longitude: 16.394657135009766,
            },
          },
          distance: 289,
        },
        {
          name: 'Dr. Thomas Heller',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.2020378112793,
              longitude: 16.38716697692871,
            },
          },
          distance: 289,
        },
        {
          name: 'myhive café',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.2006721496582,
              longitude: 16.38759422302246,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '41',
            },
          },
          distance: 292,
        },
        {
          category: 'leisure',
          subcategory: 'playground',
          location: {
            coordinates: {
              latitude: 48.19977569580078,
              longitude: 16.38861846923828,
            },
          },
          distance: 299,
        },
        {
          name: 'Bioschwestern',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20085144042969,
              longitude: 16.387285232543945,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '36',
            },
          },
          distance: 304,
        },
        {
          name: 'Ziehrerplatz',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.1992002,
              longitude: 16.391796066666668,
            },
          },
          distance: 306,
        },
        {
          name: 'Weyrgasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.204187149999996,
              longitude: 16.3887045,
            },
          },
          distance: 307,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.19961929321289,
              longitude: 16.38861846923828,
            },
          },
          distance: 313,
        },
        {
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.20145797729492,
              longitude: 16.395221710205078,
            },
          },
          distance: 313,
        },
        {
          name: 'Bella Compagnia',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20246505737305,
              longitude: 16.395214080810547,
            },
            address: {
              postCode: '1030',
              street: 'Erdbergstraße',
              city: 'Wien',
              houseNumber: '21',
            },
          },
          distance: 314,
        },
        {
          name: 'Sonnentor',
          category: 'shopping',
          subcategory: 'convenience_store',
          location: {
            coordinates: {
              latitude: 48.20415115356445,
              longitude: 16.388427734375,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '24',
            },
          },
          distance: 316,
        },
        {
          name: 'Operntheather L.E.O.',
          category: 'leisure',
          subcategory: 'entertainment',
          location: {
            coordinates: {
              latitude: 48.20275115966797,
              longitude: 16.38698959350586,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '18',
            },
          },
          distance: 316,
        },
        {
          name: 'Kimchi ToGo',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.199790954589844,
              longitude: 16.393903732299805,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '83-85',
            },
          },
          distance: 317,
        },
        {
          category: 'leisure',
          subcategory: 'playground',
          location: {
            coordinates: {
              latitude: 48.20477294921875,
              longitude: 16.391033172607422,
            },
          },
          distance: 317,
        },
        {
          name: 'Landstraßer Bürgerbeisl',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20000076293945,
              longitude: 16.39427375793457,
            },
            address: {
              postCode: '1030',
              street: 'Wassergasse',
              city: 'Wien',
              houseNumber: '36',
            },
          },
          distance: 320,
        },
        {
          name: 'Meierei',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19900894165039,
              longitude: 16.39076042175293,
            },
            address: {
              postCode: '1030',
              city: 'Wien',
            },
          },
          distance: 324,
        },
        {
          name: 'Czapkapark',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.20485305786133,
              longitude: 16.39114761352539,
            },
          },
          distance: 326,
        },
        {
          name: 'Univ.Prof. Dr. Georg Pakesch',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.199222564697266,
              longitude: 16.38907241821289,
            },
          },
          distance: 333,
        },
        {
          name: 'Städtischer Kindergarten',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.19926452636719,
              longitude: 16.393409729003906,
            },
          },
          distance: 342,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.198909759521484,
              longitude: 16.392166137695312,
            },
          },
          distance: 344,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.19898986816406,
              longitude: 16.392580032348633,
            },
          },
          distance: 344,
        },
        {
          name: 'Noodle Point',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19936752319336,
              longitude: 16.39389419555664,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '92',
            },
          },
          distance: 353,
        },
        {
          name: 'Broth3rs',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.199520111083984,
              longitude: 16.394195556640625,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '89',
            },
          },
          distance: 354,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.20512771606445,
              longitude: 16.39167022705078,
            },
          },
          distance: 359,
        },
        {
          name: 'Geusaugasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.204138650000004,
              longitude: 16.3946002,
            },
          },
          distance: 361,
        },
        {
          name: 'Shanghai Shop',
          category: 'shopping',
          subcategory: 'convenience_store',
          location: {
            coordinates: {
              latitude: 48.19944381713867,
              longitude: 16.394256591796875,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '91',
            },
          },
          distance: 363,
        },
        {
          name: 'Krazy Kitchen',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.199275970458984,
              longitude: 16.393972396850586,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '92-94',
            },
          },
          distance: 364,
        },
        {
          name: 'Das Kochwerk',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20503234863281,
              longitude: 16.38947296142578,
            },
          },
          distance: 365,
        },
        {
          name: 'Dr. Franz Widhalm',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19956970214844,
              longitude: 16.387601852416992,
            },
          },
          distance: 366,
        },
        {
          name: 'Dr. Michael Pani',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19894027709961,
              longitude: 16.388818740844727,
            },
            address: {
              postCode: '1030',
              street: 'Neulinggasse',
              city: 'Wien',
              houseNumber: '9',
            },
          },
          distance: 370,
        },
        {
          name: 'Friedrich-Zawrel-Schule',
          category: 'education',
          subcategory: 'school',
          location: {
            coordinates: {
              latitude: 48.204097747802734,
              longitude: 16.394899368286133,
            },
            address: {
              postCode: '1030',
              street: 'Hörnesgasse',
              city: 'Wien',
              houseNumber: '12',
            },
          },
          distance: 374,
        },
        {
          name: 'The Golden Harp',
          category: 'catering',
          subcategory: 'bar',
          location: {
            coordinates: {
              latitude: 48.20198440551758,
              longitude: 16.396127700805664,
            },
            address: {
              postCode: '1030',
              street: 'Erdbergstraße',
              city: 'Wien',
              houseNumber: '27',
            },
          },
          distance: 376,
        },
        {
          category: 'health',
          subcategory: 'veterinary',
          location: {
            coordinates: {
              latitude: 48.19894790649414,
              longitude: 16.38860321044922,
            },
          },
          distance: 377,
        },
        {
          name: 'Bodystreet',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.199607849121094,
              longitude: 16.387300491333008,
            },
            address: {
              street: 'Ungargasse',
              houseNumber: '46',
            },
          },
          distance: 379,
        },
        {
          name: 'Café Malipop',
          category: 'catering',
          subcategory: 'bar',
          location: {
            coordinates: {
              latitude: 48.20341110229492,
              longitude: 16.38638687133789,
            },
          },
          distance: 384,
        },
        {
          category: 'leisure',
          subcategory: 'playground',
          location: {
            coordinates: {
              latitude: 48.19853591918945,
              longitude: 16.392213821411133,
            },
          },
          distance: 385,
        },
        {
          name: 'Pergola Pizza',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20526885986328,
              longitude: 16.389711380004883,
            },
          },
          distance: 385,
        },
        {
          name: 'Dr. Sabina Islamovic',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.199180603027344,
              longitude: 16.387784957885742,
            },
          },
          distance: 389,
        },
        {
          name: 'Elianto',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19944763183594,
              longitude: 16.38729476928711,
            },
          },
          distance: 391,
        },
        {
          name: "Elvira's Restaurant",
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20497512817383,
              longitude: 16.388389587402344,
            },
            address: {
              postCode: '1030',
              street: 'Seidlgasse',
              city: 'Wien',
              houseNumber: '39',
            },
          },
          distance: 393,
        },
        {
          name: 'Arenbergpark',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.19839096069336,
              longitude: 16.391630172729492,
            },
          },
          distance: 394,
        },
        {
          name: 'Dr. Barbara Schaumann',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.203983306884766,
              longitude: 16.386682510375977,
            },
          },
          distance: 398,
        },
        {
          name: 'Café Short Break',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19919204711914,
              longitude: 16.3875732421875,
            },
            address: {
              postCode: '1030',
              street: 'Neulinggasse',
              city: 'Wien',
              houseNumber: '28',
            },
          },
          distance: 398,
        },
        {
          name: 'Universität für Musik und darstellende Kunst Wien',
          category: 'education',
          subcategory: 'university',
          location: {
            coordinates: {
              latitude: 48.202049255371094,
              longitude: 16.38565444946289,
            },
            address: {
              postCode: '1030',
              street: 'Anton-von-Webern-Platz',
              city: 'Wien',
              houseNumber: '1',
            },
          },
          distance: 401,
        },
        {
          name: 'Heunisch Und Erben',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20490264892578,
              longitude: 16.387981414794922,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '17',
            },
          },
          distance: 403,
        },
        {
          name: 'Dr Nikolaus Schaumann',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20399475097656,
              longitude: 16.38661003112793,
            },
            address: {
              postCode: '1030',
              street: 'Beatrixgasse',
              city: 'Wien',
              houseNumber: '3a',
            },
          },
          distance: 403,
        },
        {
          name: 'Dr. Leonhard Bauer',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19892120361328,
              longitude: 16.387941360473633,
            },
            address: {
              postCode: '1030',
              street: 'Neulinggasse',
              city: 'Wien',
              houseNumber: '13',
            },
          },
          distance: 405,
        },
        {
          name: 'Dr. Mathias Lidauer',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.20475769042969,
              longitude: 16.387630462646484,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '12/3',
            },
          },
          distance: 405,
        },
        {
          name: 'Zum Posthorn',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19990921020508,
              longitude: 16.386484146118164,
            },
          },
          distance: 406,
        },
        {
          name: 'Neulich',
          category: 'catering',
          subcategory: 'bar',
          location: {
            coordinates: {
              latitude: 48.19892120361328,
              longitude: 16.387855529785156,
            },
          },
          distance: 409,
        },
        {
          name: 'GarageGym',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.199493408203125,
              longitude: 16.38686752319336,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '46',
            },
          },
          distance: 411,
        },
        {
          name: 'Zahnarzt Wien Mitte',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.20451736450195,
              longitude: 16.3870849609375,
            },
            address: {
              postCode: '1030',
              street: 'Beatrixgasse',
              city: 'Wien',
              houseNumber: '3',
            },
          },
          distance: 413,
        },
        {
          name: 'Ungargasse/Neulinggasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.1990641,
              longitude: 16.38745885,
            },
          },
          distance: 414,
        },
        {
          name: 'Volkshochschule Landstraße',
          category: 'education',
          subcategory: 'university',
          location: {
            coordinates: {
              latitude: 48.20018768310547,
              longitude: 16.396034240722656,
            },
            address: {
              street: 'Hainburger Straße',
              houseNumber: '29',
            },
          },
          distance: 416,
        },
        {
          name: 'Ungargasse/Neulinggasse',
          category: 'transport',
          subcategory: 'tram',
          location: {
            coordinates: {
              latitude: 48.19905645,
              longitude: 16.38739705,
            },
          },
          distance: 418,
        },
        {
          name: 'Mrs. Sporty Landstraße',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.19832992553711,
              longitude: 16.389301300048828,
            },
            address: {
              postCode: '1030',
              street: 'Dapontegasse',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 419,
        },
        {
          name: 'Tauber',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19927215576172,
              longitude: 16.39512062072754,
            },
          },
          distance: 421,
        },
        {
          name: 'Neuling-Apotheke',
          category: 'health',
          subcategory: 'pharmacy',
          location: {
            coordinates: {
              latitude: 48.19892120361328,
              longitude: 16.387550354003906,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '51',
            },
          },
          distance: 422,
        },
        {
          name: 'Bierteufl',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.203697204589844,
              longitude: 16.386024475097656,
            },
          },
          distance: 423,
        },
        {
          name: 'Bui Vien Street',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.203739166259766,
              longitude: 16.396076202392578,
            },
            address: {
              postCode: '1030',
              street: 'Hörnesgasse',
              city: 'Wien',
              houseNumber: '17',
            },
          },
          distance: 424,
        },
        {
          name: 'Casa Latina',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.205810546875,
              longitude: 16.391138076782227,
            },
          },
          distance: 433,
        },
        {
          name: 'Laniato – Das Wiener Wollcafé',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.204681396484375,
              longitude: 16.38689613342285,
            },
            address: {
              postCode: '1030',
              street: 'Beatrixgasse',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 436,
        },
        {
          name: 'YOGAlounge',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.20548629760742,
              longitude: 16.388574600219727,
            },
            address: {
              postCode: '1030',
              street: 'Seidlgasse',
              city: 'Wien',
              houseNumber: '30',
            },
          },
          distance: 437,
        },
        {
          name: 'Café Nebenan',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20262908935547,
              longitude: 16.396883010864258,
            },
            address: {
              postCode: '1030',
              street: 'Wassergasse',
              city: 'Wien',
              houseNumber: '8',
            },
          },
          distance: 440,
        },
        {
          name: 'Tierklinik',
          category: 'health',
          subcategory: 'veterinary',
          location: {
            coordinates: {
              latitude: 48.199153900146484,
              longitude: 16.386812210083008,
            },
            address: {
              postCode: '1030',
              street: 'Neulinggasse',
              city: 'Wien',
              houseNumber: '32',
            },
          },
          distance: 440,
        },
        {
          name: 'Spar Gourmet',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.19936752319336,
              longitude: 16.395601272583008,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '99',
            },
          },
          distance: 440,
        },
        {
          category: 'leisure',
          subcategory: 'playground',
          location: {
            coordinates: {
              latitude: 48.200374603271484,
              longitude: 16.396530151367188,
            },
          },
          distance: 441,
        },
        {
          name: 'Hofer',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.1985969543457,
              longitude: 16.394426345825195,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '100',
            },
          },
          distance: 446,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.197914123535156,
              longitude: 16.39157485961914,
            },
          },
          distance: 446,
        },
        {
          name: 'Segafredo',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19931411743164,
              longitude: 16.395645141601562,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '99',
            },
          },
          distance: 447,
        },
        {
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.197906494140625,
              longitude: 16.391643524169922,
            },
          },
          distance: 448,
        },
        {
          name: 'Radici',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19864273071289,
              longitude: 16.38750457763672,
            },
          },
          distance: 449,
        },
        {
          name: 'Prim.Dr. Barbara Arbes Sertl',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.198604583740234,
              longitude: 16.387495040893555,
            },
            address: {
              street: 'Ungargasse',
              houseNumber: '53',
            },
          },
          distance: 453,
        },
        {
          name: 'Dr. Helmut Peternel',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.205440521240234,
              longitude: 16.39417839050293,
            },
          },
          distance: 455,
        },
        {
          name: 'Kindergruppe Hopphopphopp',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.20278549194336,
              longitude: 16.397045135498047,
            },
          },
          distance: 455,
        },
        {
          name: 'EnShiro Dojo Wien',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.19819259643555,
              longitude: 16.38850212097168,
            },
            address: {
              postCode: '1030',
              street: 'Dapontegasse',
              city: 'Wien',
              houseNumber: '8',
            },
          },
          distance: 455,
        },
        {
          name: 'Billa',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.19874572753906,
              longitude: 16.387174606323242,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '52',
            },
          },
          distance: 455,
        },
        {
          name: 'Prim. Dr. Gensthaler',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.198028564453125,
              longitude: 16.389026641845703,
            },
          },
          distance: 457,
        },
        {
          name: 'Dr. Alexander Roth',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.20549774169922,
              longitude: 16.38797950744629,
            },
          },
          distance: 459,
        },
        {
          name: 'Nem',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20531463623047,
              longitude: 16.38753318786621,
            },
          },
          distance: 459,
        },
        {
          name: 'Koffie',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.205108642578125,
              longitude: 16.387121200561523,
            },
          },
          distance: 459,
        },
        {
          name: 'Kinder Company',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.19782257080078,
              longitude: 16.39004135131836,
            },
          },
          distance: 461,
        },
        {
          name: 'Rasumofskygasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.20542665,
              longitude: 16.394380249999998,
            },
          },
          distance: 461,
        },
        {
          name: 'kindercompany',
          category: 'education',
          subcategory: 'kindergarten',
          location: {
            coordinates: {
              latitude: 48.20542907714844,
              longitude: 16.394380569458008,
            },
          },
          distance: 462,
        },
        {
          name: 'Toranj',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20374298095703,
              longitude: 16.38542938232422,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '6',
            },
          },
          distance: 465,
        },
        {
          name: 'Vi&Vie',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20514678955078,
              longitude: 16.38703155517578,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '6',
            },
          },
          distance: 467,
        },
        {
          name: 'Dr. Babyak Oleh',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19916534423828,
              longitude: 16.386198043823242,
            },
          },
          distance: 473,
        },
        {
          name: 'Dr. Gerhard Lang',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19816207885742,
              longitude: 16.38802719116211,
            },
          },
          distance: 474,
        },
        {
          name: 'Eurospar',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20061111450195,
              longitude: 16.397132873535156,
            },
          },
          distance: 474,
        },
        {
          name: 'Wein mag Käse',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19838333129883,
              longitude: 16.387470245361328,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '55',
            },
          },
          distance: 474,
        },
        {
          name: 'Hofladerle',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.205570220947266,
              longitude: 16.38770866394043,
            },
          },
          distance: 476,
        },
        {
          name: 'Asia Paradies',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20573425292969,
              longitude: 16.388124465942383,
            },
          },
          distance: 477,
        },
        {
          name: 'Hofer',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.20587921142578,
              longitude: 16.39357566833496,
            },
          },
          distance: 478,
        },
        {
          name: 'konzept greissler',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.19916534423828,
              longitude: 16.386077880859375,
            },
          },
          distance: 480,
        },
        {
          name: 'Hemmers',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20570755004883,
              longitude: 16.387807846069336,
            },
          },
          distance: 485,
        },
        {
          name: 'Dr. Claudia Neudecker',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19813919067383,
              longitude: 16.3876953125,
            },
          },
          distance: 488,
        },
        {
          name: 'Cafe Zartl',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.20555114746094,
              longitude: 16.394758224487305,
            },
            address: {
              postCode: '1030',
              street: 'Rasumofskygasse',
              city: 'Wien',
              houseNumber: '7',
            },
          },
          distance: 488,
        },
        {
          name: 'Bella Santi',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20390319824219,
              longitude: 16.38518714904785,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '6',
            },
          },
          distance: 489,
        },
        {
          name: 'Drei Bögen',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19832992553711,
              longitude: 16.395048141479492,
            },
          },
          distance: 497,
        },
        {
          name: 'Ärzte im Dritten',
          category: 'health',
          subcategory: 'clinic',
          location: {
            coordinates: {
              latitude: 48.20073699951172,
              longitude: 16.397539138793945,
            },
          },
          distance: 499,
        },
        {
          name: 'Barichgasse',
          category: 'transport',
          subcategory: 'bus',
          location: {
            coordinates: {
              latitude: 48.198209399999996,
              longitude: 16.3948879,
            },
          },
          distance: 501,
        },
        {
          name: 'Endomed Wien Mitte',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.205772399902344,
              longitude: 16.394567489624023,
            },
            address: {
              postCode: '1030',
              street: 'Löwengasse',
              city: 'Wien',
              houseNumber: '44',
            },
          },
          distance: 501,
        },
        {
          name: 'Dr. Ursula Fäbl-Fuchs',
          category: 'health',
          subcategory: 'dentist',
          location: {
            coordinates: {
              latitude: 48.20551300048828,
              longitude: 16.38697052001953,
            },
          },
          distance: 502,
        },
        {
          name: 'Duran',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20553207397461,
              longitude: 16.38685417175293,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '9',
            },
          },
          distance: 509,
        },
        {
          name: 'Dr. Theresa Widrich',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.2055549621582,
              longitude: 16.38687515258789,
            },
            address: {
              street: 'Landstraßer Hauptstraße',
              houseNumber: '9',
            },
          },
          distance: 510,
        },
        {
          name: 'Taste of India',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.20649337768555,
              longitude: 16.39164924621582,
            },
            address: {
              postCode: '1030',
              street: 'Marxergasse',
              city: 'Wien',
              houseNumber: '19',
            },
          },
          distance: 510,
        },
        {
          name: 'Dr. Bianca Bauer',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.204044342041016,
              longitude: 16.38496208190918,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 511,
        },
        {
          name: 'Franziskus Spital Landstraße',
          category: 'health',
          subcategory: 'hospital',
          location: {
            coordinates: {
              latitude: 48.20508575439453,
              longitude: 16.386056900024414,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '4a',
            },
          },
          distance: 512,
        },
        {
          name: 'Vegetasia',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.19796371459961,
              longitude: 16.387470245361328,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '57',
            },
          },
          distance: 514,
        },
        {
          name: 'Josef-Pfeifer-Park',
          category: 'leisure',
          subcategory: 'park',
          location: {
            coordinates: {
              latitude: 48.205848693847656,
              longitude: 16.387393951416016,
            },
          },
          distance: 515,
        },
        {
          name: 'Fitnessclub Heimlich',
          category: 'leisure',
          subcategory: 'sport',
          location: {
            coordinates: {
              latitude: 48.204078674316406,
              longitude: 16.384889602661133,
            },
            address: {
              postCode: '1030',
              street: 'Ungargasse',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 517,
        },
        {
          name: 'Dr. Clemens Hammer',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19724655151367,
              longitude: 16.391199111938477,
            },
          },
          distance: 519,
        },
        {
          name: 'Güvenli',
          category: 'shopping',
          subcategory: 'supermarket',
          location: {
            coordinates: {
              latitude: 48.2058219909668,
              longitude: 16.394908905029297,
            },
          },
          distance: 520,
        },
        {
          name: 'Nachbarschaftszentrum',
          category: 'leisure',
          subcategory: 'entertainment',
          location: {
            coordinates: {
              latitude: 48.1974983215332,
              longitude: 16.393491744995117,
            },
          },
          distance: 523,
        },
        {
          name: 'Kooperative Mittelschule Hainburger Straße',
          category: 'education',
          subcategory: 'school',
          location: {
            coordinates: {
              latitude: 48.199195861816406,
              longitude: 16.396831512451172,
            },
            address: {
              postCode: '1030',
              street: 'Hainburger Straße',
              city: 'Wien',
              houseNumber: '40',
            },
          },
          distance: 525,
        },
        {
          name: 'Apotheke "Zur heiligen Elisabeth"',
          category: 'health',
          subcategory: 'pharmacy',
          location: {
            coordinates: {
              latitude: 48.20541000366211,
              longitude: 16.38626480102539,
            },
            address: {
              postCode: '1030',
              street: 'Landstraßer Hauptstraße',
              city: 'Wien',
              houseNumber: '4',
            },
          },
          distance: 527,
        },
        {
          name: 'cafe2k',
          category: 'catering',
          subcategory: 'cafe',
          location: {
            coordinates: {
              latitude: 48.19951248168945,
              longitude: 16.39716911315918,
            },
            address: {
              postCode: '1030',
              street: 'Apostelgasse',
              city: 'Wien',
              houseNumber: '2-14/8',
            },
          },
          distance: 527,
        },
        {
          name: 'The Room',
          category: 'catering',
          subcategory: 'restaurant',
          location: {
            coordinates: {
              latitude: 48.206661224365234,
              longitude: 16.391374588012695,
            },
            address: {
              postCode: '1030',
              street: 'Marxergasse',
              city: 'Wien',
              houseNumber: '17',
            },
          },
          distance: 528,
        },
        {
          name: 'Dr. Babak Taban',
          category: 'health',
          subcategory: 'doctor',
          location: {
            coordinates: {
              latitude: 48.19725036621094,
              longitude: 16.389617919921875,
            },
          },
          distance: 529,
        },
      ],
      totalItems: 608,
    },
  },
];
